__turbopack_context__.v({
  "heroCta": "styles-module__ftrB2W__heroCta",
});
